<template>
    <div :ref="`speedometer_${dataText}`" :id="`cont_${dataText}`">
      <div :id="`speedometer_${dataText}`">
        <div :id="`back_progress_line_${dataText}`"></div>
        <!-- Línea de porcentaje base (gris claro para dar profundidad) -->
        <div :id="`progress_red_line_${dataText}`"></div>
        <div :id="`circle1_${dataText}`"></div>
        <div :id="`circle2_${dataText}`"></div>
        <div :id="`apuntador_${dataText}`"></div>
        <div :id="`circle_data_${dataText}`">
          <span :id="`percent_${dataText}`">{{ value }}{{ suffix }}</span>
          <!-- <span :id="`percent_${dataText}`">{{ Math.round(value/60) }}min</span> -->
          <!-- <span v-if="showText" :id="`text_${dataText}`">{{ dataText }}</span> -->
        </div>
        <div v-if="showText" :id="`text_${dataText}`">{{ dataText }}</div>
        <div v-for="i in lines" :key="`${i} - p`" :id="`main_line_${dataText}_${i}`"
          :style="{ transform: `rotate(${degMainLine(i)}deg) !important` }"></div>
  
        <div v-for="i in lines - 1" :key="`${i} - m`" :id="`middle_line_${dataText}_${i}`"
          :style="{ transform: `rotate(${degsecondLine(i)}deg)` }"></div>
      </div>
    </div>
  </template>
  
  <script>
  import { isNumber } from 'underscore';
import { mapState } from 'vuex';
  export default {
    props: {
      value: {
        // type: Number,
        default: null,
        required: true,
      },
      dataText: {
        type: String,
        default: '',
        required: true,
      },
      showText: {
        type: Boolean,
        default: false,
        required: false,
      },
      suffix: {
        type: String,
        default: "",
        required: false,
      },
      percent: {
        type: Number,
        default: null,
      },
      sizePx: Number,
    },
    data() {
      return {
        lines: 11,
        wearableDegrees: 280, // Max 400
        degrees: 360,
      }
    },
    methods: {
      initialize() {
        this.value = isNumber(this.value) ?  Number(this.value.toFixed(2)) : this.value;//this.value.toFixed(2);//(this.value*100).toFixed(2)
        this.asignStyles();
        const percentMove =  this.percent ?? this.value
        this.arrowMove(percentMove);
      },
      asignStyles() {
        const cont = document.getElementById(`cont_${this.dataText}`);
        cont.style.width = this.sizePx ? `${this.sizePx}px` : "21%";// : this.dataText!=`Tiempo Muerto`?this.formulaNyx?'19%':'17%':'21%';
        cont.style.aspectRatio = '1';
        cont.style.margin = this.formulaNyx?'auto 3% auto 3%':'auto';
  
  
        const speedometer = document.getElementById(`speedometer_${this.dataText}`);
        speedometer.style.width = `${this.sizePx}px` ?? '100%';
        speedometer.style.height = `${this.sizePx}px` ?? '100%';
        speedometer.style.backgroundColor = 'var(--oscuro2)';
        speedometer.style.borderRadius = '50%';
        speedometer.style.position = 'relative';
        speedometer.style.overflow = 'hidden';
        speedometer.style.display = 'flex';
        speedometer.style.alignItems = 'center';
        speedometer.style.justifyContent = 'center';
        speedometer.style.border = '1px solid #d3d3d3';
  
  
        const back_progress_line = document.getElementById(`back_progress_line_${this.dataText}`);
        back_progress_line.style.width = '100%';
        back_progress_line.style.aspectRatio = '1';
        back_progress_line.style.background = `conic-gradient(from ${180 + this.degMainLine(1)}deg, var(--base3) ${this.degMainLine(this.lines) - this.degMainLine(1)}deg ${this.degMainLine(11) - this.degMainLine(1)}deg, transparent 252deg ${this.degMainLine(this.lines) - this.degMainLine(1)}deg)`;
        back_progress_line.style.backgroundPosition = '50% 50%';
        back_progress_line.style.position = 'absolute';
        back_progress_line.style.zIndex = '1'
  
  
        const progress_red_line = document.getElementById(`progress_red_line_${this.dataText}`);
        progress_red_line.style.width = '100%';
        progress_red_line.style.aspectRatio = '1';
        progress_red_line.style.background = `conic-gradient(from 180deg, transparent ${this.startAngleLine + (this.speedometerAnglesLines / 2)}deg, rgba(255, 255, 255, 0) ${this.startAngleLine}deg, rgb(255, 0, 0) ${this.degrees - (this.startAngleLine + (this.speedometerAnglesLines / 2))}deg, transparent ${this.degrees - (this.startAngleLine + (this.speedometerAnglesLines / 2))}deg)`;
        progress_red_line.style.backgroundPosition = '50% 50%';
        progress_red_line.style.position = 'absolute';
        progress_red_line.style.zIndex = '2';
  
  
        for (let i = 0; i < this.lines; i++) {
          const middleLine = document.getElementById(`middle_line_${this.dataText}_${i}`);
          if (middleLine) {
            middleLine.style.position = 'absolute';
            middleLine.style.width = '2px';
            middleLine.style.height = '50%';
            middleLine.style.backgroundColor = 'rgb(211, 211, 211, 0.7)';
            middleLine.style.backgroundPosition = '50% 50%'
            middleLine.style.top = '50%';
            middleLine.style.left = '50%';
            middleLine.style.transformOrigin = '50% 0';
            middleLine.style.zIndex = '3';
          }
        }
  
  
        const circle1 = document.getElementById(`circle1_${this.dataText}`);
        circle1.style.width = '90%';
        circle1.style.aspectRatio = '1';
        circle1.style.background = 'var(--oscuro1)';
        back_progress_line.style.backgroundPosition = '50% 50%';
        circle1.style.borderRadius = '50%';
        circle1.style.position = 'absolute';
        circle1.style.zIndex = '4';
  
  
        for (let i = 0; i < this.lines + 1; i++) {
          const mainLine = document.getElementById(`main_line_${this.dataText}_${i}`);
          if (mainLine) {
            mainLine.style.position = 'absolute';
            mainLine.style.width = '5px';
            mainLine.style.height = '50%';
            mainLine.style.backgroundColor = 'rgb(211, 211, 211, 0.7)';
            mainLine.style.backgroundPosition = '50% 50%';
            mainLine.style.top = '50%';
            mainLine.style.left = '50%';
            mainLine.style.transformOrigin = '50% 0';
            mainLine.style.zIndex = '5';
          }
        }
  
  
        const circle2 = document.getElementById(`circle2_${this.dataText}`);
        circle2.style.width = '85%';
        circle2.style.aspectRatio = '1';
        circle2.style.background = 'radial-gradient(circle at center, #222222 10%, #131613 90%)';
        circle2.style.borderRadius = '50%';
        circle2.style.position = 'absolute';
        circle2.style.zIndex = '6';
  
  
        const apuntador = document.getElementById(`apuntador_${this.dataText}`);
        apuntador.style.position = 'absolute';
        apuntador.style.width = '5px';
        apuntador.style.height = '50%';
        apuntador.style.backgroundColor = 'white';
        apuntador.style.top = '50%';
        apuntador.style.transformOrigin = '50% 0';
        apuntador.style.transform = 'rotate(55deg)';
        apuntador.style.transition = 'transform 1s ease';
        // apuntador.style.animation = 'movimiento_apuntador 1s ease, rebote_apuntador 1s ease infinite';
        apuntador.style.zIndex = '7';
  
  
        // const progress_line = document.getElementById(`progress_line_${this.dataText}`);
        // progress_line.style.width = '100%';
        // progress_line.style.aspectRatio = '1';
        // progress_line.style.background = 'conic-gradient(var(--oscuro1) 0deg 252deg, transparent 252deg 360deg)';
        // progress_line.style.backgroundPosition = '50% 50%';
        // progress_line.style.transform = 'rotate(234deg)';
        // progress_line.style.position = 'absolute';
        // progress_line.style.display = 'flex';
        // progress_line.style.alignItems = 'center';
        // progress_line.style.justifyContent = 'center';
        // progress_line.style.top = '50%';
        // progress_line.style.transformOrigin = '50% 0';
  
  
  
        const circle_data = document.getElementById(`circle_data_${this.dataText}`);
        circle_data.style.width = '70%';
        circle_data.style.height = '70%';
        circle_data.style.aspectRatio = '1';
        circle_data.style.position = 'absolute';
        circle_data.style.borderRadius = '50%';
        circle_data.style.display = 'flex';
        circle_data.style.flexDirection = 'column';
        circle_data.style.alignItems = 'center';
        circle_data.style.justifyContent = 'center';
        circle_data.style.backgroundColor = 'var(--base3)';
        circle_data.style.color = 'white'
        circle_data.style.boxShadow = '0 10px 20px rgba(0, 0, 0, 0.3), inset 0 -5px 10px rgba(0, 0, 0, 0.2), inset 0 5px 10px rgba(255, 255, 255, 0.1)';
        circle_data.style.zIndex = '8';
  
  
        const percent = document.getElementById(`percent_${this.dataText}`);
        const parentWidthP = percent.parentElement.offsetWidth;
        const fontSizeP = parentWidthP / 2;
        percent.style.fontSize = `40px`//`${fontSizeP}px`
        // percent.style.fontSize = '5em';
        // percent.style.marginTop = 'auto';
        percent.style.color = 'white';
        percent.style.fontFamily = 'monospace';
        percent.style.fontWeight = '300';                
  
        const text = document.getElementById(`text_${this.dataText}`);
        // text.style.fontSize = '20px';
        const parentWidth = text.parentElement.offsetWidth;
        const fontSize = parentWidth / 10;

        // Ajuste especial para Glm
        if (this.nombreEmpresa === 'Glm' || this.nombreEmpresa === 'Nyx') {
          text.style.fontSize = '1.5em';
          text.style.top = '40%';
        } else {
          text.style.fontSize = `${fontSize}px`;
          text.style.top = '58%';
        }
        // text.style.marginBottom = 'auto';
        text.style.width = '50%';
        text.style.height = '50%';
        text.style.aspectRatio = '1';
        text.style.position = 'absolute';
        text.style.borderRadius = '50%';
        text.style.display = 'flex';
        text.style.flexDirection = 'column';
        text.style.alignItems = 'center';
        text.style.justifyContent = 'center';
        // text.style.backgroundColor = 'var(--base3)';
        text.style.color = 'white'
        // text.style.boxShadow = '0 10px 20px rgba(0, 0, 0, 0.3), inset 0 -5px 10px rgba(0, 0, 0, 0.2), inset 0 5px 10px rgba(255, 255, 255, 0.1)';
        text.style.zIndex = '10';
        // if (this.dataText == 'Tiempo Muerto') {
        //   text.style.right= '15%';
        //   // text.style.alignContent = 'center';
        // }
      },
  
      degMainLine(idx) {
        return (this.startAngleLine + (this.speedometerAnglesLines * idx) - this.speedometerAnglesLines / 2)
      },
      degsecondLine(idx) {
        return this.degMainLine(idx) + (this.speedometerAnglesLines / 2)
      },
      arrowMove(val) {
        let percent =  val <= 100 ? this.caculatePercentProgress(val) : this.caculatePercentProgress(100);
        let starPoint = val <= 0 ? 0 : this.startAngleLine + (this.speedometerAnglesLines / 2);
        let endPoint = percent + (this.startAngleLine + (this.speedometerAnglesLines / 2));
  
        const apuntador = document.getElementById(`apuntador_${this.dataText}`);
        apuntador.style.setProperty('--inicio-angulo', starPoint + 'deg');
        apuntador.style.setProperty('--fin-angulo', endPoint + 'deg');
  
        apuntador.style.setProperty('--angulo-inicio', endPoint + 'deg');
        apuntador.style.setProperty('--angulo-medio', endPoint + 2 + 'deg');
  
        apuntador.style.transform = `rotate(${endPoint}deg)`;
  
        if (val > 100) {
          apuntador.classList.add('apuntador-rebote');
          apuntador.style.animation = 'rebote_apuntador 1s ease infinite';
        } else {
          apuntador.classList.remove('apuntador-rebote');
          apuntador.style.animation = '';
        }
      },
      caculatePercentProgress(percent) {
        let res = (this.degMainLine(this.lines) - this.degMainLine(1)) * (percent / 100);
        return res
      }
    },
    computed: {
      startAngleLine() {
        return (this.degrees - this.wearableDegrees) / 2
      },
      speedometerAnglesLines() {
        return this.wearableDegrees / this.lines;
      },
      ...mapState({        
        formulaNyx: 'formulaNyx',
        nombreEmpresa: 'nombreEmpresa'
      }),
    },
    watch: {
      value(nv) {
        this.arrowMove(nv);
      }
    },
  mounted() {
      this.initialize();
    }
  }
  </script>
  
  <style>
  :root {
    --oscuro1: #171717;
    --oscuro2: #010101;
    --base3: #222222;
  }
  
  @keyframes movimiento_apuntador {
    0% {
      transform: rotate(var(--inicio-angulo));
    }
  
    75% {
      transform: rotate(var(--fin-angulo));
    }
  
    100% {
      transform: rotate(var(--fin-angulo));
    }
  }
  
  @keyframes rebote_apuntador {
    0% {
      transform: rotate(var(--angulo-medio));
    }
  
    10% {
      transform: rotate(var(--angulo-inicio));
    }
  
    20% {
      transform: rotate(var(--angulo-medio));
    }
  
    30% {
      transform: rotate(var(--angulo-inicio));
    }
  
    40% {
      transform: rotate(var(--angulo-medio));
    }
  
    50% {
      transform: rotate(var(--angulo-inicio));
    }
  
    60% {
      transform: rotate(var(--angulo-medio));
    }
  
    70% {
      transform: rotate(var(--angulo-inicio));
    }
  
    80% {
      transform: rotate(var(--angulo-medio));
    }
  
    90% {
      transform: rotate(var(--angulo-inicio));
    }
  
    100% {
      transform: rotate(var(--angulo-medio));
    }
  }
  
  .apuntador-rebote {
    animation: rebote_apuntador .1s ease infinite;
  }
  </style>